import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'RITROVA I TUOI ESERCIZI',
        description: "Qui ritrovi gli esercizi che hai modificato. Puoi correggerli e modificarli ancora o eliminarli dall'archivio se non ti servono più.",
        name: 'ExercisesInLibraryNavItem',
        tutorialName: 'archivio_tab-esercizi'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE',
        xOffset: 5,
        yOffset: 0
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 12,
        yOffset: 0
    }
};
